import { render, staticRenderFns } from "./PagePushNotifications.vue?vue&type=template&id=433aa6a5&scoped=true"
import script from "./PagePushNotifications.vue?vue&type=script&lang=js"
export * from "./PagePushNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433aa6a5",
  null
  
)

export default component.exports